// removed by extract-text-webpack-plugin
module.exports = {"base":"RatingLabel_base--2SDiO","isDisabled":"RatingLabel_isDisabled--_yWEe","vehicleLevelIcon":"RatingLabel_vehicleLevelIcon--3b0Ml","level-6":"RatingLabel_level-6--2hMAx","level6":"RatingLabel_level-6--2hMAx","level-8":"RatingLabel_level-8--2bL6q","level8":"RatingLabel_level-8--2bL6q","level-10":"RatingLabel_level-10--3-IpA","level10":"RatingLabel_level-10--3-IpA"};


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/RatingLabel/RatingLabel.scss
// module id = 2189
// module chunks = 11